module.exports = __webpack_public_path__ + "img/20191123151044360截图20191123145554826.7bf0bffa.jpg";